var render = function render(){var _vm=this,_c=_vm._self._c;return _c('messages-list',{attrs:{"customerID":_vm.customerID,"requestWhere":_vm.requestWhere,"routePath":'lista-wiadomosci'}})
}
var staticRenderFns = []

export { render, staticRenderFns }